import styled from "styled-components";
import { FiAlertTriangle } from "react-icons/fi";
import { H3, H4 } from "../../elements";
import { useNavigate } from "react-router-dom";
import { IApprovalHistoryCounts } from "../../types";

const ProductWrapper = styled.div`
  width: 100%;
  height: 19rem;
  box-shadow: ${({ theme }) => theme.shadow.shad_100};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.4rem;
  animation: productIn 0.5s forwards 0.2s;
  opacity: 0;
  transform: scale(0.95);
  padding-bottom: 1rem;

  /* Mobile first approach for the card width */
  @media screen and (min-width: 512px) {
    max-width: 18rem;
  }
  /*
  @media screen and (min-width: 1100px) {
    width: 32%;
  }

  @media screen and (min-width: 1340px) {
    width: 23.875%;
  } */

  @keyframes productIn {
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .image-wrapper {
    width: 100%;
    height: 9rem;
    overflow: hidden;
    background-color: #b1cdf8;
    position: relative;
  }
  img {
    width: 100%;
  }

  .resubmission-flag {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    background-color: ${({ theme }) => theme.text.danger};
    color: white;
    font-size: 0.7rem;
    font-weight: 500;
  }

  .texts {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    padding: 0.5rem 0.7rem;
  }

  button {
    width: 5rem;
    height: 2.2rem;
    cursor: pointer;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border-radius: 0.25rem;
    border: 1px solid ${({ theme }) => theme.bg.secondary};

    .icon {
      color: ${({ theme }) => theme.text.inverted};
      font-size: 1.5rem;
    }
  }
`;

export interface IProductProps {
  imageUrl: string;
  brand: string;
  name: string;
  size: string;
  id: string;
  strength: number;
  strengthUnit: string;
  form: string;
  baseUrl: string;
  onView?: (id: string) => void;
  onApprove?: boolean;
  /**
   * MED-653: approval-history counts, served per product by the admin
   * approvals queue only. Drives the frequent-resubmission flag (OI-06) so a
   * suspicious change pattern is visible before the product is opened.
   */
  historySummary?: IApprovalHistoryCounts;
}

const NewH4 = styled(H4)`
  text-transform: capitalize;
  font-size: 0.85rem;
`;

export function Product({
  imageUrl,
  brand,
  name,
  baseUrl,
  id,
  strength,
  strengthUnit,
  onView,
  onApprove,
  form,
  historySummary,
}: IProductProps) {
  const navigate = useNavigate();

  const handleClick = (id: string) => {
    if (onApprove) {
      navigate(baseUrl + "/" + id);
    } else if (onView) {
      onView(id);
    }
  };

  return (
    <ProductWrapper>
      <div className="image-wrapper">
        <img src={imageUrl} alt={brand} />

        {historySummary?.frequent_resubmission ? (
          <span
            className="resubmission-flag"
            title={`Edited and resubmitted ${historySummary.resubmission_count} times — at or above the review threshold of ${historySummary.frequent_resubmission_threshold}`}
          >
            <FiAlertTriangle />
            Resubmitted {historySummary.resubmission_count}x
          </span>
        ) : null}
      </div>

      <div className="texts">
        <H3>{brand + "(" + form + ")"}</H3>
        <NewH4>{name}</NewH4>
        <H4>
          {strength}
          {strengthUnit === "milligrams" ? "mg" : "g"}
        </H4>
      </div>

      <button onClick={() => handleClick(id)}>View</button>
    </ProductWrapper>
  );
}
